import React from "react";


const PricingCard = ({ plan, highlight }) => (
  <div
    className={`rounded-2xl shadow-lg p-6 md:p-8 flex flex-col items-center text-center border-2 transition-all duration-300 bg-white w-full max-w-xs mx-auto mb-8 md:mb-0
      ${highlight ? 'border-btn-primary bg-btn-secondary-base bg-opacity-40 scale-105 ring-2 ring-btn-primary' : 'border-gray-200'}
    `}
    style={{ minHeight: 420 }}
  >
    <h2 className={`text-xl md:text-2xl font-bold mb-2 tracking-tight ${highlight ? 'text-btn-primary' : 'text-btn-secondary-text'}`}>{plan.name}</h2>
    <div className="flex flex-col items-center mb-4">
      <span className="text-3xl md:text-4xl font-extrabold text-btn-primary">{plan.price}</span>
      {plan.billing && <span className="text-xs md:text-sm text-gray-500">{plan.billing}</span>}
      {plan.save && <span className="text-xs text-green-600 font-semibold mt-1">Save {plan.save}</span>}
    </div>
    <ul className="mb-6 space-y-2 text-left w-full max-w-xs mx-auto">
      {plan.features.map((f, i) => (
        <li key={i} className="flex items-center gap-2 text-gray-700 text-sm md:text-base">
          <span className={`inline-block w-2 h-2 rounded-full ${f.positive ? 'bg-green-500' : 'bg-red-500'}`}></span>
          <span className={f.positive ? '' : 'text-red-600 font-semibold'}>{f.label}</span>
        </li>
      ))}
    </ul>
    <button
      className={`w-full py-2.5 md:py-3 px-6 rounded-full font-bold text-base md:text-lg shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-btn-primary focus:ring-offset-2
        ${highlight
          ? 'bg-btn-primary text-btn-primary-text hover:bg-btn-primary-hover hover:scale-105'
          : 'bg-btn-secondary text-btn-secondary-text hover:bg-btn-secondary-hover hover:scale-105'}
      `}
      style={{ letterSpacing: 1 }}
      onClick={() => window.location.href = '/signup'}
    >
      Choose {plan.name}
    </button>
    {plan.note && <div className="mt-2 text-xs text-gray-500">{plan.note}</div>}
  </div>
);

export default PricingCard;
